import { render } from "./RemindersTab.vue?vue&type=template&id=1a638194&scoped=true"
import script from "./RemindersTab.vue?vue&type=script&lang=js"
export * from "./RemindersTab.vue?vue&type=script&lang=js"

import "./RemindersTab.vue?vue&type=style&index=0&id=1a638194&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a638194"]])

export default __exports__